import { ActivityIndicator, Text } from "react-native-paper";
import { ScreenContainer, Button } from "../../components";
import { Platform, View } from "react-native";
import Barcode from "react-barcode";
import { CURRENT_MEMBER_QUERY, EVENT_REGISTRATION_QUERY } from "./queries";
import { useQuery } from "@apollo/client";
import PgaLogo from "../../svgs/PgaLogo";
import React, { useEffect } from "react";
import { CurrentMemberQuery, EventDetailsQuery, EventRegistrationQuery } from "./types";
import { EVENT_DETAILS_QUERY } from "./EventDetailsScreen";
import { ScreenProps } from "../types";

export default function EventTicketScreen({ navigation, route }: ScreenProps<"EventTicket">) {
  const { data } = useQuery<CurrentMemberQuery>(CURRENT_MEMBER_QUERY);

  const { data: registrationData, loading } = useQuery<EventRegistrationQuery>(EVENT_REGISTRATION_QUERY, {
    variables: { slug: route.params.slug },
  });

  const { data: eventDetails, loading: detailsLoading } = useQuery<EventDetailsQuery>(EVENT_DETAILS_QUERY, {
    variables: { slug: route.params.slug },
  });

  const isRegistered = !!registrationData?.eventRegistration?.registeredAt;
  const hasPrintablePass = !!eventDetails?.event?.printablePass;
  useEffect(() => {
    if (loading || detailsLoading) {
      return;
    }

    if (data && isRegistered && Platform.OS === "web" && hasPrintablePass) {
      window.print();
    }
  }, [data, isRegistered, loading, detailsLoading, hasPrintablePass]);

  if (loading || detailsLoading) {
    return <ActivityIndicator className="flex-1 items-center justify-center" testID="query-loader" />;
  }

  if (!isRegistered) {
    navigation.navigate("EventDetails", { slug: route.params.slug });
  }

  if (!hasPrintablePass) {
    navigation.navigate("EventConfirmation", { slug: route.params.slug });
  }

  return (
    <ScreenContainer noBorder>
      <View className="flex lg:flex-row p-6">
        <View>
          <Text className="text-title-4 font-700">
            PGA of America{"\n"}Member Access Pass{"\n"}2024 Masters Tournament
          </Text>
          <Text className="font-500 text-small-normal mt-4">Available for use:</Text>
          <Text className="text-large-normal font-700 uppercase">Mon, April 8 - Sun, April 14</Text>

          <Text className="font-500 text-small-normal mt-4">Present at:</Text>
          <Text className="text-large-normal font-700 uppercase">North Gate</Text>
          <Text className="text-small-normal">
            *Follow signs to PGA Booth at Gate C located to the{"\n"}far right of North Gate Pavilion
          </Text>

          <Text className="text-large-normal font-700 uppercase mt-4">This is not a ticket</Text>
        </View>
        <View className="p-4 flex-1 ml-9 border-2 border-sky-light rounded-lg justify-center items-center mt-6">
          <View className="self-center">
            <View className="self-center mb-3">
              <PgaLogo />
            </View>
            <Barcode value={data?.currentMember?.id || ""} />
            <Text className="text-large-normal self-center">
              {data?.currentMember?.firstName} {data?.currentMember?.lastName}
            </Text>
          </View>
        </View>
      </View>

      <View className="border-t border-dashed border-sky mt-7 p-6">
        <View className="mt-10">
          <Text className="text-title-4 font-700">YOU MUST BRING THESE ITEMS EACH DAY OF ATTENDANCE</Text>
          <Text className="font-700 text-regular-normal">
            <ul>
              <li>THIS PASS: Print and bring this pass EACH DAY</li>
              <li>PHOTO ID</li>
              <li>PGA OF AMERICA MEMBERSHIP CARD</li>
            </ul>
          </Text>
        </View>

        <View className="mt-8">
          <Text className="text-title-4 font-700">Know Before You Go</Text>
          <Text className="font-700 text-regular-normal">
            <ul>
              <li>Cell Phones are strictly prohibited on the grounds of Augusta National at all times.</li>
              <li>Tickets are non-transferrable</li>
              <li>Entries are limited to 2 per day</li>
            </ul>
          </Text>
        </View>
        <Button mode="contained" onPress={() => window.print()} className="mt-8 lg:max-w-xs">
          Print
        </Button>
      </View>
    </ScreenContainer>
  );
}
